export default {"src":"/_next/static/media/lock.1c662ed7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};